import {
  Bar,
  XAxis,
  CartesianGrid,
  Tooltip,
  BarChart,
  ResponsiveContainer,
} from "recharts";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "white",
          padding: 10,
          border: "1px solid rgb(204, 204, 204)",
        }}
      >
        <p style={{ marginBottom: "10px" }}>{`موضوع : ${data.subject}`}</p>{" "}
        <p>{`${data.percentage}%`}</p>
      </div>
    );
  }
  return null;
};

const BarChartComponent = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart width={350} height={20} data={data} barSize={15}>
        <CartesianGrid strokeDasharray="0" />
        <XAxis dataKey="subject" height={0} />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="percentage" fill="#4b495b" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarChartComponent;
